import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';

import Logo from '../components/Logo';

import '../../css/TargetHours.css'

import SCHOOLS_DETAILS from '../constants/SchoolsDetails';

import Big from 'big.js';
import Button from '../components/Button';
import Search from '../components/Search';

const TargetHours = () => {

	const history = useHistory();

	let schoolSlug = useParams().schoolRollNumberSlug;
	const schoolArray = SCHOOLS_DETAILS.filter(schoolEntry => schoolEntry.rollNumber === schoolSlug);
	const selectedSchoolObj = schoolArray[0];

	const [customHours, setCustomHours] = useState("");

	return (
		<div>
			<Logo
				onClick={() => history.push("/")}
				showRetry={"yes"}
			>{selectedSchoolObj.schoolName}</Logo>

			{selectedSchoolObj.SETHours === "0"
			?	<div className="cluster-hour-option">
					<header>		
						<h2>No new hours!</h2>
					</header>
					<section>
						<h3>According to our database, your school has 0 SET Hours</h3>
						<h3>If this is an error, please fill in this form, and we'll fix the issue right away!</h3>
					</section>
					<Button
						onClick={() => window.open(`https://forms.gle/NvxD1Zf1HDFrQu1F8`)}
						className=""
					>Report an error</Button>	
				</div>
			: <div className="cluster-hour-option">
					<header>		
						<h2>Recommended</h2>
					</header>
					<section>
						<h3>You have {new Big(selectedSchoolObj.SETHours).mod(25).toString()} leftover SET Allocation hours.</h3>
						<h3>We think you need to find a cluster of <span className="color-highlight">{new Big(selectedSchoolObj.SETHours).mod(25).minus(25).abs().toString()} hours</span> to match with. Searching for ONE school may increase the distance between you and them.</h3>
						<h3></h3>
					</section>
					<span>
					<Button
						onClick={() => history.push(`/schoolmatcher/recommended/${schoolSlug}`)}
						className=""
					>Find ANY Cluster</Button>

					<Button
						onClick={() => history.push(`/schoolmatcher/recommended/${schoolSlug}/single`)}
						className=""
					>Find ONE School</Button>
					</span>
				</div>
			}

			<h1 id="bigOr">OR</h1>

			<div className="cluster-hour-option">
				<header>
					<h2>Custom</h2>
				</header>
				<section>
					<h3>Set your own custom cluster hours in the box below</h3>
					{customHours >= 25 ?
						<h3>The number must be lower than 25!</h3>
					:
						<>
							<h3>Find a cluster of <span className="color-highlight">{customHours === "" ?  "[x]" : customHours} hours</span> to match with </h3>
							{customHours && !isNaN(customHours) &&
								<p><em>i.e. including your school's, you have <b>{new Big(customHours).minus(25).abs().toString()} SET Allocation hours</b> sorted</em></p>
							}
						</>
					}
					
				</section>
				<Search
					value={customHours}
					onChange={e => setCustomHours(e.target.value)}
					placeholder="Tell us how many hours you need"
				/>
				{customHours && !isNaN(customHours) && customHours < 25 &&
				<Button
					onClick={() => history.push(`/schoolmatcher/${customHours}/${schoolSlug}`)}
					className=""
				>Find a cluster!</Button>
			}
			</div>		
			
		</div>
	)
}



const mapStateToProps = state => ({
	selectedSchoolIndex: state.selectedSchoolIndexState
})


const mapDispatchToProps = dispatch => ({
})

export default connect(
	mapStateToProps, 
	mapDispatchToProps,
)(TargetHours);
